const LOADED_CLASS = 'mosaicPopup__imgLink--loaded';

const tracked = new WeakSet();

const findPhoto = (el) => el?.querySelector('img');

// Listened for up front, while the mosaic is still hidden and its lazy photos can't have loaded:
// a photo already on screen when the mosaic opens is fetched by the browser itself, possibly
// before the observer below gets to it, and its load event would otherwise be missed.
const hideSkeletonWhenPhotoArrives = (photo) => {
  const markLoaded = () => photo.closest('.mosaicPopup__imgLink')?.classList.add(LOADED_CLASS);

  photo.addEventListener('load', markLoaded, { once: true });
  photo.addEventListener('error', markLoaded, { once: true });
};

const showPhoto = (el) => {
  const photo = findPhoto(el);
  if (!photo || tracked.has(photo)) {
    return;
  }
  tracked.add(photo);

  // How far native lazy loading looks ahead inside a scroll container differs between browsers;
  // this keeps the next photos' head start the same everywhere.
  photo.loading = 'eager';
};

export default function initMosaicLazyLoading() {
  const mosaic = document.querySelector('.mosaicPopup');

  mosaic?.querySelectorAll('.mosaicPopup__img img').forEach(hideSkeletonWhenPhotoArrives);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      showPhoto(entry.target);

      const parent = entry.target.parentElement;

      // preload next out of view port if exists
      const preloadNext = [
        parent.nextElementSibling, // might be null!
        parent.nextElementSibling?.nextElementSibling,
      ];

      preloadNext.forEach((el) => {
        showPhoto(el?.querySelector('.mosaicPopup__img'));
      });

      observer.unobserve(entry.target);
    });
  }, {
    // Not just any .ds-modal-wrapper: the room page renders other DS modals ahead of this one.
    root: mosaic,
  });

  return observer;
}
